import { FormControl } from '@mui/material';
import { useState } from 'react';
import { QuestionOption } from '../../models/Question';
import { QuestionProps } from '../question-wrapper/QuestionRenderer';
import QuestionHeader from '../question-header/QuestionHeader';
import AuditInfo from '../audit-info/AuditInfo';
import QuestionRow from '../question-wrapper/QuestionRow';
import { getInitialsFromEmail } from '../../utils/initialsUtils';
import { getUserEmail } from '../../utils/authProvider/authProvider';
import AutoComplete from '../auto-complete/AutoComplete';
import TextField from '../text-field/TextField';

const QuestionDropdown = (props: QuestionProps) => {
  const { question, handleSave, required, showMandatoryFieldError } = props;

  const mappedOptions = question.options
    ? [...question.options].sort((a: QuestionOption, b: QuestionOption) => a.displayValue.localeCompare(b.displayValue))
    : [];

  const initialValue = mappedOptions.find((opt) => opt.value === question.value) ?? null;
  const [value, setValue] = useState<QuestionOption | null>(initialValue);
  const [lastUpdatedBy, setLastUpdatedBy] = useState(question.updatedByEmail);
  const [lastUpdatedTime, setLastUpdatedTime] = useState(question.timeStampValue);

  const handleChange = (answer: QuestionOption | null) => {
    question.value = answer?.value ?? '';
    handleSave?.(question.value);
    setValue(answer);
    setLastUpdatedBy(getInitialsFromEmail(getUserEmail()));
    setLastUpdatedTime(new Date().toISOString());
  };

  const handleClose = () => {
    setTimeout(() => {
      const activeElement = document.activeElement as HTMLElement | null;
      if (activeElement) {
        activeElement.blur();
      }
    }, 0);
  };

  return (
    <div>
      <QuestionHeader
        text={question.text}
        required={required}
        helpText={question.helpText}
        error={showMandatoryFieldError && required && !value}
      />
      <QuestionRow>
        <FormControl fullWidth>
          <AutoComplete
            onChange={(_, newValue) => handleChange(newValue)}
            getOptionLabel={(option) => option?.displayValue ?? ''}
            options={mappedOptions}
            value={value}
            isOptionEqualToValue={(option, val) => option.value === val?.value}
            renderInput={(params) => <TextField {...params} />}
            fullWidth
            onClose={handleClose}
          />
        </FormControl>
        <AuditInfo updatedByEmail={lastUpdatedBy} updatedTimeStamp={lastUpdatedTime} size="24px" />
      </QuestionRow>
    </div>
  );
};

export default QuestionDropdown;
